import React, { Fragment, useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export default function Filter({ searchFunction, loading, color, onSubmit }) {
  const [searchInput, setsearchInput] = useState("");

  useEffect(() => {
      searchFunction(searchInput);
  }, [searchInput, searchFunction]);

  return (
    <Fragment>
      <TextField
        fullWidth
        size="small"
        label="Search"
        value={searchInput}
        onChange={(e) => setsearchInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onSubmit?.();
          }
        }}
        disabled={loading}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
    </Fragment>
  );
}
